import { pointAPI } from '@/services-ts/axios'
import type { IRewardCategory } from '@/types/Data/PointAPI'
import type {
  IGetRewardList,
  IPayloadReward,
  IPayloadRewardCategory,
} from '@/types/Request/PointAPI'
import type { IRewardStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'
export const useRewardStore = defineStore('reward', {
  state: (): IRewardStore => ({
    rewardList: [],
    rewardCategoryList: [],
    sodexoRewardList: [],
  }),

  actions: {
    async GetRewardCategoryList() {
      const payload = {
        ParentId: null,
        Skip: 0,
        Take: 100,
        IsAdmin: true,
      }
      const data = await pointAPI.RewardServices.GetRewardCategoryList(payload)
      const list = data as unknown as IRewardCategory[]
      this.rewardCategoryList = sortSubCategories(sortFunction(list))
    },

    async CreateRewardCategory(payload: IPayloadRewardCategory) {
      const { status } = await pointAPI.RewardServices.CreateRewardCategory(payload)

      if (status) {
        void Alert({
          message: Format('admin_reward_custom_rewardcreateedit_rewardcreated'),
          type: 'success',
        })
        await this.GetRewardCategoryList()
      }
    },

    async UpdateRewardCategory(payload: IPayloadRewardCategory) {
      const { status } = await pointAPI.RewardServices.UpdateRewardCategory(payload)

      if (status) {
        void Alert({ message: Format('admin_global_success'), type: 'success' })
        await this.GetRewardCategoryList()
      }
    },

    async DeleteRewardCategory(Id: string) {
      const { status } = await pointAPI.RewardServices.DeleteRewardCategory(Id)

      if (status) {
        void Alert({ message: Format('admin_global_success'), type: 'success' })
        await this.GetRewardCategoryList()
      }
    },

    async GetRewardList(payload: IGetRewardList) {
      const { status, data } = await pointAPI.RewardServices.GetRewardList(payload)
      this.rewardList = status ? data : []
    },

    async CreateReward(payload: IPayloadReward) {
      const { status } = await pointAPI.RewardServices.CreateReward(payload)

      if (status) {
        void Alert({
          message: Format('admin_reward_custom_rewardcreateedit_rewardcreated'),
          type: 'success',
        })
      }
      return status
    },

    async UpdateReward(data: IPayloadReward) {
      const { status } = await pointAPI.RewardServices.UpdateReward(data)

      if (status) {
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
      return status
    },

    async DeleteReward(Id: string) {
      const { status } = await pointAPI.RewardServices.DeleteReward(Id)

      if (status) {
        this.rewardList = this.rewardList.filter(item => item.id !== Id)
        void Alert({ message: Format('admin_global_deleted'), type: 'success' })
      }
    },

    async GetSodexoRewardList() {
      const { status, data } = await pointAPI.RewardServices.GetSodexoRewardList()
      this.sodexoRewardList = status ? data : []
    },
  },
})

const sortSubCategories = (data: IRewardCategory[]) => {
  data.forEach((item: IRewardCategory) => {
    if (item.subCategories) {
      item.subCategories = sortFunction(item.subCategories)
      sortSubCategories(item.subCategories)
    }
  })
  return data
}

const sortFunction = (data: IRewardCategory[]) => {
  data.sort((a, b) => {
    const isLetterOrNumber = (char: string) => /^[\p{L}\p{N}]/u.test(char)

    const aIsLetterOrNumber = isLetterOrNumber(a.name.charAt(0))
    const bIsLetterOrNumber = isLetterOrNumber(b.name.charAt(0))

    if (!aIsLetterOrNumber && bIsLetterOrNumber) {
      return -1
    }
    if (aIsLetterOrNumber && !bIsLetterOrNumber) {
      return 1
    }
    return a.name.localeCompare(b.name)
  })

  return data
}
